import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" path="/404" />
      <section className="flex min-h-[60vh] items-center justify-center">
        <div className="container-kx text-center">
          <Zap className="mx-auto h-12 w-12 text-amber-400" />
          <h1 className="mt-6 font-display text-6xl font-extrabold uppercase text-white">404</h1>
          <p className="mt-3 text-neutral-400">The page you're looking for isn't here.</p>
          <Link to="/" className="mt-8 inline-flex rounded-full bg-amber-400 px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-[#0A0A0C] hover:bg-amber-300">
            Back to home
          </Link>
        </div>
      </section>
    </>
  );
}
